import { z } from 'zod';
/**
 * Health-Response — Phase-0-Contract zwischen Server und Web.
 * Shared Zod-Schema als einzige Typquelle für Client + Server (06 – Tech-Stack).
 */
export const healthResponseSchema = z.object({
    status: z.literal('ok'),
    service: z.literal('familynest-api'),
    version: z.string(),
    uptimeSeconds: z.number().nonnegative(),
    timestamp: z.string(),
});
//# sourceMappingURL=health.js.map